import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { PaginationComponent } from "../pagination/pagination.component";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { DatePipe } from '@angular/common';
import * as Globals from '../globals';
const url = Globals.serviceUrl;
declare var $: any;

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {
  @ViewChild(PaginationComponent) child: PaginationComponent;

  userProfile: any;
  be: any[];
  authMenu: any;
  loading: boolean;
  search: string = '';
  tab: number = 1;
  p: number = 1;
  reverse: boolean = false;
  colSort: string[];
  col: number = 1;
  all: boolean;
  pagedList: any;
  pageNumber: number = 1;
  pageSize: number = 10;
  timeSch: string;
  user: any;
  users: any[];
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private route: ActivatedRoute, private router: Router, private profileService: ProfileService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.userProfile = { PARENT_GROUP_ID: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/email/0') {
          this.tab = 1;
          this.router.navigate(['/email/1']);
        }
      };
    });
  }
  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['SUBJECT'];
        break;
      case 2:
        this.colSort = ['TIME_SCH'];
        break;
      case 3:
        this.colSort = ['CD_STATUS'];
        break;
      default:
        break;
    }
  }
  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/email/1']);
    }
    this.New();
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      //console.log(this.child);
      this.getemailBlasts(1);
      this.authMenu = Globals.getAuthMenu(800, this.userProfile);
    }
  }

  New() {
    this.tab = 1;
    //this.user = new APP_USERS(0, null, null, '', null, null, null, null, null, null, null, null, null);
  }

  refreshParent() {
    this.tab = 1;
    this.getemailBlasts(1);
  }

  getemailBlasts(pageNumber: number) {
    this.loading = true;
    this.all = true;
    //console.log(this.tab);
    //console.log(pageNumber);
    //this.pagedList = {};
    this.be = [];
    this.http.get(url + 'ritel/blastemail?search=' + this.search + '&pageNumber=' + pageNumber + '&pageSize=' + this.pageSize + '&sort=' + this.colSort + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.pagedList = res.json();
        this.be = this.pagedList.Model.Records;
        this.pageNumber = pageNumber;
        //console.log(this.pageNumber);
        //console.log(this.pagedList.Model);
        this.child.getPagination(this.pageNumber, this.pagedList.Model);
        // for (var i = 0; i < this.be.length; i++) {
        //   if (this.be[i].ConfirmBy == 0) {
        //     this.be[i].ConfirmBy = '';
        //   }
        //   this.getUsers(this.be[i].CreatedBy);
          //this.be[i].CreatedName = this.user.USERNAME;
          //console.log(this.users);
          //this.getUsers(this.be[i].ConfirmBy);

          // this.be.ConfirmName = ;
          // this.timeSch = toString(this.be[i].TimeSch);
          // this.be[i].TimeSch = new Date(this.timeSch);
          // this.be[i].TimeSch = new Date(this.be[i].TIME_SCH);
          // console.log(this.timeSch);
          // console.log(this.be[i].TimeSch);
        //}
        //this.getCds(28);
        //this.getSeriesSa();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  // getUsers(userId: number){
  //   this.loading = true;
  //   this.http.get(Globals.serviceUrl + 'ref/user?id=' + userId + '&t' + new Date().getTime(), { headers: this.headerService.getHeader() })
  //     .subscribe((res: Response) => {
  //       this.user = res.json();
  //       //this.users.push(this.user);
  //       console.log(this.user);
  //       this.loading = false;
  //     }, err => {
  //       console.log(err);
  //       this.toastr.error(Globals.errorMessage(err));
  //       this.loading = false;
  //     });
  // }

  pageChange(pageNumber: number) {
    if (this.all) {
      this.getemailBlasts(pageNumber);
    }
  }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/email/email.component.ts